import {ApplicationConfig,enableProdMode,ErrorHandler,inject,provideAppInitializer} from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment.prod';
import { Router } from "@angular/router";
import { captureConsoleIntegration } from '@sentry/browser';


export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
};

if(environment.production){
  Sentry.init({
    dsn: "https://4fd4a7b45121dfc307894c3bdcaecd2a@o1268873.ingest.us.sentry.io/4508748593299456",
    environment: environment.sentryName,
    integrations: [
      Sentry.browserTracingIntegration(),     
      captureConsoleIntegration({
        levels: ['error'],
      }),
      Sentry.replayIntegration(),
    ],   
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', 'app.financerazor.com', 'financerazor.com'],
    // Session Replay
    replaysSessionSampleRate: environment.sentryReplaysRate, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

if (environment.production) {
  enableProdMode();
}


platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  }).catch(err => console.error(err));

  